import {PayloadAction, createSlice} from '@reduxjs/toolkit';

import {orderWithDistributorAndRetailerT} from '@/lib/types/order.types';

interface ORDER_STATE {
  orders: orderWithDistributorAndRetailerT[];
  isLoading: boolean;
  error: string | null;
}

const ORDER_INITIAL: ORDER_STATE = {
  orders: [],
  isLoading: false,
  error: null,
};

const orderSlice = createSlice({
  name: 'order',
  initialState: ORDER_INITIAL,
  reducers: {
    ORDER_UPDATE: (
      state,
      action: PayloadAction<{
        data?: Partial<ORDER_STATE>;
        prop?: keyof ORDER_STATE;
        value?: string | Date | boolean | number;
      }>
    ) => {
      if (action.payload.data) {
        Object.entries(action.payload.data).forEach(([key, value]) => {
          if (key in state) {
            (state as any)[key] = value;
          }
        });
        return state;
      }

      if (action.payload.prop && action.payload.value !== undefined) {
        const prop = action.payload.prop;

        // Narrow the assignment to only properties that exist on the state
        if (prop in state) {
          (state as any)[prop] = action.payload.value;
        }
      }

      return state;
    },
  },
});

const {ORDER_UPDATE} = orderSlice.actions;

export {orderSlice, ORDER_INITIAL, ORDER_UPDATE};
